export default __webpack_public_path__ + "static/media/gamification-loot-box.2f90e0da.png";